import React, { PropsWithChildren } from "react";
import { PrimaryButton, OutlineButton, LinkButton } from "./atom";
import { ThemeType } from "../../constants";
import { CSSProperties } from "styled-components";
import { LoadingIcon } from "../../assets";

export function Button({
  type = "primary",
  children,
  loading,
  ...props
}: ButtonProps) {
  const StyledButton = {
    primary: PrimaryButton,
    default: PrimaryButton,
    outline: OutlineButton,
    link: LinkButton,
  }[type] as React.ElementType;
  return (
    <StyledButton
      type={type}
      $loading={loading}
      disabled={props.disabled || loading}
      {...props}
    >
      {children}
      {loading && <LoadingIcon className="loading-icon" />}
    </StyledButton>
  );
}

export type ButtonType = "primary" | "outline" | "link" | "default";

export type ButtonProps = PropsWithChildren<
  Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "type"> & {
    type?: ButtonType;
    themeType?: ThemeType;
    loading?: boolean;
    height?: string;
    width?: string;
    disabled?: boolean;
    backgroundHover?: string;
    backgroundDisable?: string;
    color?: string;
    default?: boolean;
    style?: CSSProperties;
    className?: string;
    onClick?: (e?: React.MouseEvent<HTMLButtonElement>) => void;
  }
>;
